/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { meMeGet } from '../fn/me/me-me-get';
import { MeMeGet$Params } from '../fn/me/me-me-get';
import { BackendMeProfileResponseDto } from '../models/backend-me-profile-response-dto';

@Injectable({ providedIn: 'root' })
export class BackendApiMeService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `meMeGet()` */
  static readonly MeMeGetPath = '/me';

  /**
   * Профиль текущего пользователя.
   *
   * Бизнес-данные текущего пользователя из master-БД + сводка доступных проектов. В отличие от `/auth/me`, ходит в БД и обогащает данные.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `meMeGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  meMeGet$Response(
    params?: MeMeGet$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendMeProfileResponseDto>> {
    return meMeGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Профиль текущего пользователя.
   *
   * Бизнес-данные текущего пользователя из master-БД + сводка доступных проектов. В отличие от `/auth/me`, ходит в БД и обогащает данные.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `meMeGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  meMeGet(params?: MeMeGet$Params, context?: HttpContext): Observable<BackendMeProfileResponseDto> {
    return this.meMeGet$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendMeProfileResponseDto>): BackendMeProfileResponseDto => r.body),
    );
  }
}
